import Registry from "../registry";
import React from "react";
import S from "string";

const text = {
  name: "Text",
  group: "Basic",
  options: {
    default_value: { label: "Default Value" },
    formatting: {
      label: "Formatting",
      type: "string",
      allowedValues: { plain: "Plain", html: "HTML" },
      nullOption: false
    }
  },
  schema: part => ({
    type: "string",
    component: locals => (
      <input
        type="text"
        className="form-control"
        value={locals.value || ""}
        onChange={e => locals.onChange(e.target.value)}
      />
    ),
    render: ({ value }) => {
      if (!value) return part.default_value || null;
      const { formatting } = part;
      if (formatting === "plain") {
        return S(value).stripTags().s;
      }

      return value;
    }
  })
};

Registry.register("text", text);

export default text;



// WEBPACK FOOTER //
// ./app/parts/text.js